import React from "react";

import CheckboxControl from "components/Form/CheckboxControl";
import Form from "components/Form/CompatForm";
import {
    StyledContainerRow,
    StyledLabel,
} from "./TrunkFormRefactored.styles";

import { Input } from "rsuite";

const NonDialerTrafficRoute = ({
    formRef,
    model,
    error,
    disabled,
    organicState,
    formDefaultValue,
    setError,
    onFilledOrEmpty,
    onValidityChange,
    setOrganicState,
}) => {
    const errorObject = error["trafficRouteError"] || {};

    const disabledOnNotAllFieldsFilled = !(organicState.organic_ip && organicState.organic_port && organicState.organic_login && organicState.organic_password);

    return <Form
        ref={formRef}
        model={model}
        layout="inline"
        formDefaultValue={formDefaultValue}
        formValue={organicState}
        onChange={(value) => {
            const formCheck = model.check(value);
            const errors = {};

            const formErrors = Object.keys(formCheck).reduce((data, key) => {
                if (formCheck[key].hasError) {
                    data[key] = formCheck[key].errorMessage;
                }
                return data;
            }, errors);

            setError((prevValue) => {
                return {
                    ...prevValue,
                    trafficRouteError: formErrors
                };
            });

            setOrganicState(value);

            const hasErrors = Object.values(formCheck).some(v => v?.hasError);
            const valid = !hasErrors;
            if (typeof onValidityChange === "function") onValidityChange(valid);
            if (typeof onFilledOrEmpty === "function") {
                const filled = {
                    ip: String(value.organic_ip ?? "").trim() !== "",
                    port: value.organic_port === 0 || String(value.organic_port ?? "").trim() !== "",
                    login: String(value.organic_login ?? "").trim() !== "",
                    pass: String(value.organic_password ?? "").trim() !== "",
                };
                const any = filled.ip || filled.port || filled.login || filled.pass;
                const all = filled.ip && filled.port && filled.login && filled.pass;
                const isNotFilledOrEmpty = any && !all;

                onFilledOrEmpty(isNotFilledOrEmpty);
            }

            const isAllEmpty = Object.keys(value).every((key) => {
                return !value[key];
            });

            if (formRef.current && formRef.current.cleanErrors && isAllEmpty) {
                formRef.current.cleanErrors();
                setError((prevValue) => {
                    const { trafficRouteError: _, ...restPrevValue } = prevValue;
                    return {
                        ...restPrevValue
                    };
                });
            }

        }}
        style={{ margin: "0px", width: "100%" }}
        formError={errorObject}
    >
        <StyledContainerRow start mb={0}>
            <StyledContainerRow mb={0}>
                <StyledLabel width={30} margin="0px">
                    IP
                </StyledLabel>
                <Form.Control
                    accepter={Input}
                    name="organic_ip"
                    disabled={disabled}
                    errorPlacement="topRight"
                    placeholder="Enter IP"
                    style={{ width: 130 }}
                />
            </StyledContainerRow>
            <StyledContainerRow mb={0}>
                <StyledLabel width={35} margin="0px">
                    Port
                </StyledLabel>
                <Form.Control
                    accepter={Input}
                    name="organic_port"
                    disabled={disabled}
                    errorPlacement="topRight"
                    placeholder="Enter port"
                    style={{ width: 90 }}
                />
            </StyledContainerRow>
            <StyledContainerRow mb={0}>
                <StyledLabel width={70} margin="0px">
                    SystemID
                </StyledLabel>
                <Form.Control
                    accepter={Input}
                    name="organic_login"
                    disabled={disabled}
                    errorPlacement="topRight"
                    placeholder="Enter system ID"
                    style={{ width: 185 }}
                />
            </StyledContainerRow>
            <StyledContainerRow mb={0}>
                <StyledLabel width={70} margin="0px">
                    Password
                </StyledLabel>
                <Form.Control
                    accepter={Input}
                    name="organic_password"
                    disabled={disabled}
                    errorPlacement="topRight"
                    placeholder="Enter password"
                    style={{ width: 125 }}
                />
            </StyledContainerRow>
            <StyledContainerRow mb={0}>
                <CheckboxControl
                    name="organic_use_ssl"
                    disabled={disabled || disabledOnNotAllFieldsFilled}
                    checked={organicState?.organic_use_ssl || false}
                >
                    Use SSL
                </CheckboxControl>
            </StyledContainerRow>
            <StyledContainerRow mb={0}>
                <CheckboxControl
                    name="pass_all_traffic_to_organic"
                    disabled={disabled || disabledOnNotAllFieldsFilled}
                    checked={organicState?.pass_all_traffic_to_organic || false}
                >
                    Pass all traffic (including dialers)
                </CheckboxControl>
            </StyledContainerRow>
        </StyledContainerRow>
    </Form>;
};

export default NonDialerTrafficRoute;
